import Card from './Card';
import classes from './Menu.module.css';
const Menu = props => {
    return (
        <section className='section-padding'>
            <div className="container">
            <div className="row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="area-title text-center">
                        <h2>Today's Menu</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className={classes.menulist}>
                        <ul>
                            <li className="filter active" data-filter="all">All</li>
                            <li className="filter" data-filter=".breakfast">Breakfast</li>
                            <li className="filter" data-filter=".lunch">Lunch</li>
                            <li className="filter" data-filter=".dinner">Dinner</li>
                            <li className="filter" data-filter=".coffee">Coffe</li>
                            <li className="filter" data-filter=".snacks">Snacks</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-6 col-sm-12 col-xs-12 ">
                <Card src="https://media.self.com/photos/5f189b76c58e27c99fbef9e3/1:1/w_768,c_limit/blackberry-vanilla-french-toast.jpg" title="Sample" content="lorem ipsem avcd"/>
                <Card src="https://media.self.com/photos/5f189b76c58e27c99fbef9e3/1:1/w_768,c_limit/blackberry-vanilla-french-toast.jpg" title="Sample" content="lorem ipsem avcd"/>
                
                </div>
                <div className="col-md-12 col-lg-6 col-sm-12 col-xs-12">
                <Card src="https://media.self.com/photos/5f189b76c58e27c99fbef9e3/1:1/w_768,c_limit/blackberry-vanilla-french-toast.jpg" title="Sample" content="lorem ipsem avcd"/>
                </div>
            </div>
            </div>
            </section>
    )
}

export default Menu;